import { useOrgSettings } from "./OrgSettingsContext";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Info } from "lucide-react";

export function GeneralSettings() {
  const { organizationName, organizationSubdomain } = useOrgSettings();

  return (
    <div className="space-y-6">
      {/* Organization Information - Read Only */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Info className="h-5 w-5" />
            Organization Information
          </CardTitle>
          <CardDescription>
            Basic information about this organization.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Organization Name</Label>
              <div className="text-sm text-gray-900 dark:text-white font-medium">
                {organizationName || "N/A"}
              </div>
            </div>
            <div className="space-y-2">
              <Label>Subdomain</Label>
              <div className="text-sm text-gray-900 dark:text-white font-medium">
                {organizationSubdomain || "N/A"}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
